import React, { Component } from 'react';
import logo from './logo.png';
import {
  Link
} from 'react-router-dom';


class Header extends Component {
  render() {
    return (
      <header>

        <div className="logo">
            <img src={logo} className="Header-logo" alt="logo" />
        </div>

        <nav>
          <ul>
            <li className="first">
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/Gallery">Gallery</Link>
            </li>
            <li>
              <Link to="/Contact">Contact</Link>
            </li>
            <li className="last">
              <a
                className="App-link"
                href="https://pankumedia.bigcartel.com"
                target="_blank"
                rel="noopener noreferrer"
                >
                  Merch
              </a>
            </li>
          </ul>
        </nav>

      </header>
    );
  }
}

export default Header;
